import React, {Component} from "react";
import {ID_FINISH} from "../../../scripts/constants";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {Button, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import {getTimeTextForHour24, getToken, loadTimeSlots, scheduleCall} from "../../../scripts/scheduler";
import calendar from "../../../assets/images/calendar.png"
import {isValid, mygaSession} from "../../../scripts/myga-session";

import './ScheduleCall.css';
import {charLimits, regex, NassauLog} from "../../../scripts/myga-utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Resources from "../../../Resources/Resources";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";

class ScheduleCall extends Component {
  
  constructor(props) {
    super(props);
    // this.nextPage = props.nextPage || PAGES.pageLanding; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
  
    let nextState = {
      errorMessage: '',
      timezone: '',
      requestedDate: '',
      requestedTime: '',
      days: [],
      slots: [],
      isBusy: false,
      edit: false
    };
  
    let idFinish = mygaSession.getCurrentAppIdFinish();
    NassauLog(`idFinish: ${JSON.stringify(idFinish)}`);
    nextState[ID_FINISH.daytimePhone] = idFinish[ID_FINISH.daytimePhone];
    
    // Load the component state from the current application
    this.state = nextState;
    
  }
  
  componentDidMount() {

    this.getTimeSlots();
    
    getToken()
        .then((token)=>{
          NassauLog(`dtcToken: ${token}`);
          this.dtcToken = token;
        })
        .catch((err)=> {
          NassauLog(err);
        });
  }
  
  getTimeSlots() {
    this.setState({
      isBusy: true
    },()=>{
      loadTimeSlots(this.state.requestedDate)
          .then((schedule)=>{
            NassauLog(`schedule: ${JSON.stringify(schedule)}`);
            let nextState = {
              isBusy: false,
              errorMessage: ''
            };
            if (isValid(schedule.days)) {
              nextState.days = schedule.days;
              nextState.requestedDate = schedule.days[0].id;
            }
            if (isValid(schedule.slots)) {
              nextState.slots = schedule.slots;
            }
            if (isValid(schedule.timezone))  {
              nextState.timezone = schedule.timezone;
            }
            this.setState(nextState)
          })
          .catch((err)=>{
            NassauLog(err);
            this.setState({
              isBusy: false,
              errorMessage: err.message,
              requestedDate: '',
              days: [],
              slots: [],
            })
          });
    })
  }
  
  // 2021.02.26.ADivelbiss - We are intercepting the update page in case there is an error
  // with scheduling the appointment.  A better way to do this in the future may be
  // to catch an error in the regular flow.  See AppContentWrapper line 96-97
  updatePage = (nextPage) => {
    
    if (this.state.requestedDate==='') {
      this.setState({
        errorMessage:MYGAStrings.ScheduleCall_MissingDateError
      });
      return;
    }
  
    if (this.state.requestedTime==='') {
      this.setState({
        errorMessage:MYGAStrings.ScheduleCall_MissingTimeError
      });
      return;
    }
  
    scheduleCall(this.dtcToken,this.state.requestedDate, this.state.requestedTime, this.state.timezone)
        .then((data)=>{
          NassauLog(`scheduleCall response: ${JSON.stringify(data,null,2)}`);
        })
        .catch((err)=>{
          NassauLog(err.message);
        })
    
    // if (this.props.updatePage) {
    //   this.props.updatePage(nextPage);
    // }
    
  };
  
  // 2021.10.04.ADivelbiss - updating to work
  validate = () => {
    if (this.state.requestedDate==='') {
      this.setState({
        errorMessage:MYGAStrings.ScheduleCall_MissingDateError
      });
      return false;
    }
  
    if (this.state.requestedTime==='') {
      this.setState({
        errorMessage:MYGAStrings.ScheduleCall_MissingTimeError
      });
      return false;
    }
  
    return true;
  }
  
  
  getDateText() {
    let text = '';
    if (this.state.days.length>0 && this.state.requestedDate.length>0) {
      text = this.state.days.filter((item) => {
        return (item.id === this.state.requestedDate);
      })[0].text
    }
    return text;
  }
  
  renderSlots() {
    return (
        <>
          {
            this.state.slots.length > 0 ? (
                <div className={''}>
                  {
                    this.state.slots.map((item,index)=>{
                      return (
                          <Button variant="primary" size="sm" key={index}
                              onClick={()=>{ this.setState({requestedTime: item.start, errorMessage: ''})  }}
                          >
                            {getTimeTextForHour24(item.start)}
                          </Button>
                      )
                    })
                  }
                </div>
                ) : (
                <div>
                  There are no times available for this day.
                </div>
            )
          }
        </>
    )
  }
  
  render() {
    return (
        <AppContentWrapper
            nextLabel = {MYGAStrings.ScheduleCall_ButtonScheduleCall}
            validateOnNext={this.validate}
            onNextPressed={this.submitApplication}
            updatePage={this.updatePage} // different han usual
            errorMessage={this.state.errorMessage}
        >
  
          {/* page header */}
          <Container>
            <Row className="pt-0 mt-0">
              <Col xs={3} md={2}>
                <img src={calendar} alt="calendar icon" />
              </Col>
              <Col className="">
                <Col className="">
                  <h3>Schedule a call</h3>
                </Col>
                <Col className="">
                  <p>You can schedule a call with us. Pick a day and an available time slot that works for you.</p>
                </Col>
              </Col>
            </Row>
          </Container>
  
          {
            (this.state.requestedDate==='' && this.state.isBusy) ? (
                    <Container className="page-answer-select">
                      <Row className={'text-center'}>
                        <Col>
                          <Spinner
                              as="span"
                              animation="border"
                              size="lg"
                              role="status"
                              aria-hidden="true"
                          />
                        </Col>
                      </Row>
                    </Container>
                ) :
                (this.state.requestedTime==='') ? (
            
                    <Container className="scheduler">
                      {/* Date Selector */}
                      <Row className="page-answer-select">
                        <Col xs={12} sm={2} className="text-left">
                          <div>Date: </div>
                        </Col>
                        <Col xs={12} sm={10} md={6} className="text-left">
                          <select className={"form-control page-select"}
                                  required
                                  value={this.state.requestedDate}
                                  onChange={(event)=>{
                                    this.setState({
                                      requestedDate: event.target.value
                                    },()=>{
                                      this.getTimeSlots()
                                    })
                                  }}>
                            {
                              this.state.days.map((item, index)=>{
                                return <option key={index} value={item.id}>{item.text}</option>
                              })
                            }
                          </select>
                        </Col>
                      </Row>
              
                      {/* Instructions */}
                      <Row className={'pb-3'}>
                        <Col className={'border-bottom'}>
                          <label>Select an available time for an appointment ({this.state.timezone})</label>
                        </Col>
                      </Row>
              
                      {/* Time slot selection buttons */}
                      <Row className={'pb-3'}>
                        <Col xs={12} sm={4} className={''}>
                          <div>{this.getDateText()}</div>
                        </Col>
                        {
                          this.state.isBusy ? (
                              <Col xs={12} sm={8} className={'text-center'}>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="lg"
                                    role="status"
                                    aria-hidden="true"
                                />
                              </Col>
                          ) : (
                              <Col xs={12} sm={8} >
                                {
                                  this.renderSlots()
                                }
                              </Col>
                          )
                        }
                      </Row>
              
                      {/* Phone number display and edit form */}
                      <Row className={'pb-3'}>
                        <Col xs={12} sm={4} className={''}>
                          <div>We will call you at: </div>
                        </Col>
                        <Col xs={12} sm={6} md={4} >
                          {
                            this.state.edit ? (
                                <Form inline className={'auth-form needs-validation'}
                                      ref={(form) => {
                                        this.pageForm = form;
                                      }}>
                                  <Form.Group>
                                    <Form.Control
                                        type="text" required
                                        className="page-input"
                                        name={ID_FINISH.daytimePhone}
                                        value={this.state[`${ID_FINISH.daytimePhone}_edit`]}
                                        onChange={(e)=>{
                                          let nextState = {};
                                          nextState[`${ID_FINISH.daytimePhone}_edit`] = e.target.value;
                                          nextState.errorMessage = '';
                                          this.setState(nextState);
                                        }}
                                        placeholder="Daytime Phone Number"
                                        pattern={regex.phoneNumberUS}
                                        maxLength={charLimits.phoneNumberUS}
                                    />
                                    <Button variant="link" size="" onClick={()=>{
                                      if (!this.pageForm.checkValidity()) {
                                        this.pageForm.classList.add('was-validated');
                                        this.setState({
                                          errorMessage: MYGAStrings.ScheduleCall_PhoneNumberError
                                        })
                                      } else {
                                        let nextState = { edit: false};
                                        nextState[ID_FINISH.daytimePhone] = this.state[`${ID_FINISH.daytimePhone}_edit`];
                                        this.setState(nextState);
                                      }
                                    }}>
                                      <FontAwesomeIcon icon={Resources.Icons.Check}/>
                                    </Button>
                                    <Button variant="link" size="" onClick={()=>{
                                      this.setState({ edit: false })
                                    }}>
                                      <FontAwesomeIcon icon={Resources.Icons.TrashCan}/>
                                    </Button>
                                  </Form.Group>
                                </Form>
                            ) : (
                                <>
                                  {this.state[ID_FINISH.daytimePhone]}
                                  <Button variant="link" size="" onClick={()=>{
                                    let nextState = { edit: true};
                                    nextState[`${ID_FINISH.daytimePhone}_edit`] = this.state[ID_FINISH.daytimePhone];
                                    this.setState(nextState);
                                  }}>
                                    <FontAwesomeIcon icon={Resources.Icons.Pencil}/>
                                  </Button>
                                </>
                            )
                          }
                        </Col>
                      </Row>
            
                    </Container>
                ) : (
                    <Container>
                      
                      {/* Schedule summary */}
                      <Row className={'border-bottom mt-5 pt-1'}>
                        <Col className={'text-left'}>
                          We will call you at:
                        </Col>
                        <Col className={'text-left'}>
                          Date:
                        </Col>
                        <Col className={'text-left'}>
                          Time:
                        </Col>
                      </Row>
                      <Row className={'pt-1'}>
                        <Col className={'text-left'}>
                          {this.state[ID_FINISH.daytimePhone]}
                        </Col>
                        <Col className={'text-left'}>
                          {this.getDateText()}
                        </Col>
                        <Col className={'text-left'}>
                          {getTimeTextForHour24(this.state.requestedTime)}
                          <Button variant="link" size="" onClick={()=>{
                            let nextState = { requestedTime: ''};
                            this.setState(nextState);
                          }}>
                            <FontAwesomeIcon icon={Resources.Icons.Pencil}/>
                          </Button>                        </Col>
                      </Row>
  
                      {/* Instructions */}
                      <Row className={'p-5'}>
                        <Col className={'text-center'}>
                          <p>You’re almost there.</p><p>Review your appointment details and finalize by selecting the Schedule Call button.</p>
                        </Col>
                      </Row>

                    </Container>
                )
          }
          
        </AppContentWrapper>
    )
  }
}

export default ScheduleCall;